import { useState, useCallback } from "react";

export default function useWifiSetupState() {
    const [isOpen, setIsOpen] = useState(false);

    const openSetup = useCallback(() => {
        setIsOpen(true);
    }, []);

    const closeSetup = useCallback(() => {
        setIsOpen(false);
    }, []);

    return { isOpen, openSetup, closeSetup };
}
